import {
	CheckIcon,
	CreditCardIcon,
	EllipsisHorizontalIcon,
	ExclamationCircleIcon,
	PencilSquareIcon,
	PhotoIcon,
	ChatBubbleOvalLeftEllipsisIcon,
} from "@heroicons/react/20/solid";
import { format } from "date-fns";
import React from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/timesheetActions";

const TimesheetRow = ({
	locationOptions,
	timesheet,
	timesheetSetOpenModal,
	salary,
	noName,
	userPermissions,
	timesheetSave,
	timesheetGetPreview,
}) => {
	const workLocation = locationOptions?.find((location) => location.id == timesheet.workLocation)?.name;
	// console.log('inRow',timesheet)
	const urlSegments = window.location.href.split("/");
	const location = urlSegments[urlSegments.length - 2];
	return (
		<tr
			style={{
				// opacity : timesheet.status == 'deleted' ? 0.5 : 1
				color: timesheet.status == "deleted" ? "rgba(255,0,0,.5)" : "inherit",
			}}
			className={
				salary?.employmentType === 501
					? "employmentType-FT"
					: salary?.employmentType
						? "employmentType-PT"
						: "employmentType-C"
			}
		>
			{location == "organisation" && <td></td>}
			<td></td>
			<td>{format(new Date(timesheet.date), "EEE, dd/MM/yyyy")}</td>
			<td
				style={{
					textDecoration: timesheet.status === "deleted" ? "line-through" : "none",
				}}
			>
				<div style={{ float: "left", marginRight: 5 }}>{timesheet.hours}</div>
				{timesheet.isPaid && <CreditCardIcon style={{ height: "1.5em", float: "left" }} />}
			</td>
			<td>{timesheet["time-in"]}</td>
			<td>{timesheet["time-out"]}</td>
			<td>{workLocation || ""}</td>
			<td>{timesheet.break || "0"}</td>
			<td>
				{userPermissions != "Read" && (
					<div style={{ float: "left", marginRight: "5px" }}>
						<a
							className="t-edit-timesheet btn btn-xs btn-default"
							onClick={() => {
								timesheetSetOpenModal(true, timesheet);
							}}
						>
							{timesheet?.status == "deleted" ? (
								<PencilSquareIcon
									className="h-5 w-5 text-dark-gray"
									style={{ marginTop: "3px" }}
								/>
							) : (
								<PencilSquareIcon
									className="h-5 w-5 text-dark-gray"
									style={{ marginTop: "3px" }}
								/>
							)}
						</a>
					</div>
				)}

				{timesheet.note && (
					<a
						style={{ float: "left", marginRight: "5px" }}
						className="btn btn-xs btn-default"
						title="Show Comments"
						onClick={() => {
							timesheetSetOpenModal(true, timesheet);
						}}
					>
						<ChatBubbleOvalLeftEllipsisIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</a>
				)}

				{timesheet.photo && (
					<a
						style={{ float: "left", marginRight: "5px" }}
						className="btn btn-xs btn-default"
						title="Show Photo"
						onClick={() => {
							timesheetGetPreview(timesheet.photo[0].key, true);
						}}
					>
						<PhotoIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</a>
				)}

				{userPermissions != "Read" &&
					["pending", "requires review"].includes(timesheet?.status?.toLowerCase?.()) && (
						<div
							style={{ float: "left", marginRight: "5px" }}
							className="btn btn-xs btn-success"
							title="Approve Timesheet"
							onClick={() => {
								timesheetSave({
									...timesheet,
									status: "Approved",
								});
							}}
						>
							<CheckIcon
								className="h-5 w-5 text-dark-gray"
								style={{ marginTop: "3px" }}
							/>
						</div>
					)}

				{userPermissions != "Read" && timesheet?.status?.toLowerCase?.() == "incomplete" && (
					<div
						style={{ float: "left", marginRight: "5px" }}
						className="btn btn-xs btn-warning"
						title="Incomplete"
						onClick={() => {
							timesheetSetOpenModal(true, timesheet);
						}}
					>
						<EllipsisHorizontalIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				)}

				{userPermissions != "Read" && timesheet?.status?.toLowerCase?.() == "requires review" && (
					<div
						style={{ float: "left", marginRight: "5px" }}
						className="btn btn-xs btn-warning"
						title="Requires Review"
						onClick={() => {
							timesheetSetOpenModal(true, timesheet);
						}}
					>
						<ExclamationCircleIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				)}

				{userPermissions != "Read" && timesheet?.file && (
					<div
						style={{ float: "left", marginRight: 5 }}
						className="btn btn-xs btn-default"
						title="Image Preview"
						onClick={() => timesheetGetPreview(timesheet.file)}
					>
						<PhotoIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: 3 }}
						/>
					</div>
				)}
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {
	// console.log('state',state && state.timesheets)
	const locationOptions = state.workLocation?.workLocationSettings?.types?.map((location) => ({
		id: location.id,
		name: location.name,
	}));
	const userPermissions = state?.permissions?.my?.permissions?.timesheets;

	return {
		// ...state.timesheets,
		locationOptions,
		userPermissions,
	};
};

const mapDispatchToProps = (dispatch) => ({
	timesheetGetPreview: (fileKey, regularTimesheet) =>
		dispatch(ACTIONS.timesheetGetPreview(fileKey, regularTimesheet)),
	timesheetSetOpenModal: (status, timesheet) => dispatch(ACTIONS.timesheetSetOpenModal(status, timesheet)),
	timesheetSave: (timesheet) => dispatch(ACTIONS.timesheetSave(timesheet)),
	//showComments: (timesheet) => dispatch(ACTIONS.showComments(timesheet)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetRow);
